<template>
  <v-card width="500" flat>
    <v-card-title class="mb-6">
      <v-row no-gutters justify="center">
        <img
          src="@/assets/images/kloner_logo_black.svg"
          width="260"
          alt=""
          class="mr-4"
        />
      </v-row>
    </v-card-title>

    <v-card-text>
      <v-form v-model="valid" @submit.prevent="login">
        <v-row no-gutters>
          <v-text-field
            outlined
            dense
            v-model="credentials.email"
            label="Email"
            name="email"
            prepend-inner-icon="mdi-email"
            type="text"
            autocomplete="username"
            :rules="[formRules.email]"
          ></v-text-field>
        </v-row>

        <v-row no-gutters>
          <v-text-field
            outlined
            dense
            id="password"
            v-model="credentials.password"
            label="Password"
            name="password"
            prepend-inner-icon="mdi-lock"
            type="password"
            autocomplete="current-password"
            :rules="[formRules.required]"
          ></v-text-field>
        </v-row>

        <v-row no-gutters justify="center">
          <v-btn
            color="primary"
            type="submit"
            depressed
            :loading="$store.state.auth.loading"
            :disabled="!valid"
          >
            Log in
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'LoginForm',
  data: () => ({
    valid: false,
    credentials: {
      email: '',
      password: ''
    },
    formRules: {
      required: v => !!v || 'This field is required.',
      email: v => /.+@.+\..+/.test(v) || 'Must be a valid email.'
    }
  }),
  methods: {
    login() {
      this.$store.dispatch('auth/login', this.credentials).then(() => {
        if (this.$route.query && this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      })
    }
  }
}
</script>
